module.exports = __webpack_public_path__ + "img/afghanistan.d6549f86.svg";